import { render, staticRenderFns } from "./ReminderMailManageView.vue?vue&type=template&id=6a663c23&scoped=true"
import script from "./ReminderMailManageView.vue?vue&type=script&lang=js"
export * from "./ReminderMailManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a663c23",
  null
  
)

export default component.exports